module.exports = __webpack_public_path__ + "img/yangyi_pink.bf4742bf.png";